<template>
  <div class="hello">
    <h3>【 Village 】   app サポートページ</h3>
    <p>iOS/ダウンロードリンク（公開後対応）</p>
    <p>お問い合わせ : xagri4158@gmail.com</p>

    <h3>【Village】プライバシーポリシー</h3>
    <div class="privacy">
        <p>【Village】（以下「当方」という）は、当方の提供する【アプリ名】の利用者（以下「ユーザー」という）に関する個人情報を含んだ情報（以下「ユーザー情報」という）の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」という）を定めます。</p>

        <h4>１．情報を取得するアプリ提供者</h4>
        <p>【Village】</p>

        <h4>２．取得するユーザー情報と目的</h4>
        <p>本アプリケーションで取得するユーザー情報はありません。</p>

        <h4>３．取得方法</h4>
        <p>なし。</p>

        <h4>４．通知・公表または同意取得の方法・利用者関与の方法</h4>
        <p>（１）通知・公表</p>
        <p>当方は、本ポリシーに関する通知・公表は本アプリケーションに掲載する方法で行います。</p>

        <p>（２）同意取得の方法</p>
        <p>なし。</p>

        <p>（３）利用者関与の方法</p>
        <p>なし。</p>

        <h4>５．外部送信・第三者提供・情報収集モジュール</h4>
        <p>（１）外部送信</p>
        <p>なし。</p>

        <p>（２）第三者提供</p>
        <p>なし。</p>

        <p>（３）情報収集モジュール</p>
        なし。

        <h4>６．お問い合わせ</h4>
        <p>当方のプライバシーポリシーに関する、ご意見、ご質問、苦情の申出その他ユーザー情報の取扱いに関するお問い合わせは、以下の窓口にご連絡ください。</p>
        <p>xagri4158@gmail.com</p>

        <h4>７．改定</h4>
        <p>当方は、当方の裁量に基づいて、本ポリシーを変更します。但し、取得するユーザー情報、利用目的、第三者提供に変更が発生した場合、本アプリケーションで通知するとともに、本ポリシー変更後、本アプリケーションの初回起動時に改めてユーザーから同意を取得します。</p>

        <h4>8．制定日・改定日</h4>
        <p>制定：2023年2月10日</p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
  cursor: pointer;
}
.privacy {
  text-align: left;
}
</style>
